//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[],[[["machineName","attName","value"],"EditMachineLibrary",{},3,0],[["selectedMachineName"],"InsertEntryToMachineLibrary",{R_:{machineName:''}},1,0],[["machineName"],"RemoveEntryFromMachineLibrary",{},1,0],[["machineCount"],"GetAllMachineNames",{R_:{machineNames:""}},0,0],[["attributeCount"],"GetAllAttributeNames",{R_:{attributeNames:""}},0,0],[["machineName","attName"],"GetValue",{R_:{value:''}},2,0]],[]];
SPLM.SIM.MachineLibraryBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.MachineLibraryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;